import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const DownloadIcon = createIcon(
  'Download',
  <path d="M15.8348199,9.43533408 L14.5075076,9.43533408 L14.5075076,4.90588901 C14.5075076,4.40765006 14.1318532,4 13.67272,4 L10.3335697,4 C9.87443648,4 9.49878206,4.40765006 9.49878206,4.90588901 L9.49878206,9.43533408 L8.17146979,9.43533408 C7.42850884,9.43533408 7.05285442,10.4136942 7.5787706,10.9844043 L11.4104456,15.1424349 C11.7360128,15.4957316 12.261929,15.4957316 12.5874961,15.1424349 L16.4191712,10.9844043 C16.9450874,10.4136942 16.5777808,9.43533408 15.8348199,9.43533408 Z M5,18 C5,18.6416667 5.45,19.1666667 6,19.1666667 L18,19.1666667 C18.55,19.1666667 19,18.6416667 19,18 C19,17.3583333 18.55,16.8333333 18,16.8333333 L6,16.8333333 C5.45,16.8333333 5,17.3583333 5,18 Z" />
);

export default DownloadIcon;
